import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchApiData } from "../../redux/reducers/commonApiSlice";
import { pt_transfer_history } from "../../data/ApiEndpoints";
import CmnFilters from "../lead-management/common/CmnFilters";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { convertStraight } from "../common-data/Converts";

const TransferHistory = ({ userInfoData, rowData }) => {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.common);

  const [isPage1, setIsPage1] = useState(0);
  const [pageLimit1, setPageLimit1] = useState(10);
  const iniAllFilter = {
    selectedTransferFrom: "",
    selectedTrainer: "",
    selAddedby: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    subscription_id: rowData?.subscription_id || "",
    page: isPage1 + 1,
    limit: pageLimit1 || 10,
    transferred_from: allFilters.selectedTransferFrom?.value || "",
    transferred_to: allFilters.selectedTrainer?.value || "",
    transferred_by: allFilters.selAddedby?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniPTDatas = {
    ptTransferHistory: [],
    ptTransferHistoryPagination: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  function getCardDetail(filters) {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: pt_transfer_history,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (filters.subscription_id) {
      getCardDetail(filters);
    }
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage1 + 1,
      limit: pageLimit1 || 10,
      transferred_from: allFilters.selectedTransferFrom?.value || "",
      transferred_to: allFilters.selectedTrainer?.value || "",
      transferred_by: allFilters.selAddedby?.value || "",
    }));
  }, [
    isPage1,
    pageLimit1,
    allFilters.selectedTransferFrom,
    allFilters.selectedTrainer,
    allFilters.selAddedby,
  ]);

  useEffect(() => {
    if (data?.status && data?.data?.length > 0 && !loading && !error) {
      setAllDatas((prevs) => ({
        ...prevs,
        ptTransferHistory: data.data,
        ptTransferHistoryPagination:
          data?.pagination?.length > 0 ? data.pagination : [],
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        ptTransferHistory: [],
        ptTransferHistoryPagination: [],
      }));
    }
  }, [data, loading, error]);

  const tbColumnsTransfer = [
    {
      dataField: "user_id",
      text: "member detail",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.user_name || "NA"}
            <br />
            <small className="lowercase underline gray">
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "transferred_from",
      text: "transferred from",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.transferred_from_name || "NA"}
            <br />
            <small className="lowercase underline gray">
              {row?.transferred_from_mobile || ""}
              <br />
              {row?.transferred_from_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "transferred_to",
      text: "transferred to",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.transferred_to_name || "NA"}
            <br />
            <small className="lowercase underline gray">
              {row?.transferred_to_mobile || ""}
              <br />
              {row?.transferred_to_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "transferred_by",
      text: "transferred by",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.transferred_by_name || "NA"}
            <br />
            <small className="lowercase underline gray">
              {row?.transferred_by_mobile || ""}
              <br />
              {row?.transferred_by_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "transferred_reason",
      text: "Transfer reason",
      formatter: (cell, row) => (
        <span className="tb-data small-text">
          {row?.transferred_reason || "NA"}
        </span>
      ),
    },
    {
      dataField: "date_added",
      text: "Transfer Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? convertStraight(row.date_added) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <CmnFilters
        from={"pt-transfer-history"}
        userInfoData={userInfoData}
        onClickReset={onResetFilters}
        filters={allFilters}
        setFilters={setAllFilters}
        isLoading={loading}
      />

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.ptTransferHistory}
            tableColumns={tbColumnsTransfer}
            tablePagination={allDatas.ptTransferHistoryPagination}
            isPage={isPage1}
            setIsPage={(value) => setIsPage1(value)}
            pageLimit={pageLimit1}
            setPageLimit={setPageLimit1}
          />
        )}
      </div>
    </>
  );
};

export default TransferHistory;
